import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for member events hooks
 * Keys match backend controller method names
 */
export const memberEventsKeys = {
  getMemberEvents: (memberUuid: string, params?: QueryParamsDto) =>
    params
      ? (["member-events", memberUuid, "getMemberEvents", params] as const)
      : (["member-events", memberUuid, "getMemberEvents"] as const),
} as const
